import { useCallback, useState } from 'react'

/**
 * Значение, которым владеет либо потребитель, либо сам компонент.
 *
 * Пропс задан — компонент только сообщает о желаемой смене и ничего не хранит;
 * не задан — держит значение у себя. Обработчик вызывается в обоих режимах: он и есть
 * событие «пользователь попросил другое значение», а не «состояние изменилось».
 *
 * Вынесено на третьем повторении (Popover, Select, Combobox), до того копия жила в каждом.
 */
export function useControllableState<T>(
  controlledValue: T | undefined,
  defaultValue: T,
  onChange?: (next: T) => void,
): [T, (next: T) => void] {
  const [innerValue, setInnerValue] = useState(defaultValue)
  const controlled = controlledValue !== undefined
  const value = controlled ? controlledValue : innerValue

  const setValue = useCallback(
    (next: T) => {
      if (!controlled) setInnerValue(next)
      onChange?.(next)
    },
    [controlled, onChange],
  )

  return [value, setValue]
}
